export enum TariffServiceStatus {
    NOT_EXIST = "Не существует",
    AVAILABLE = "Доступна",
    ACTIVE = "Активна",
    DISABLE = "Отключена"
}
